<template>
    <div class="queuing-info">
        <div class="queuing-title"></div>
        <div class="queuing-now">您当前处于第 <span style="color: #E33535;margin: 0 5px;">{{ person }}</span> 位</div>
        <div class="queuing-time"></div>
        <div class="queuing-arrow"></div>
        <div class="account-box">
            <div class="account-box-main">
                <div>{{  secondsToTime(holdTime, 'day')[0] }}</div>
                <span class="unit">天</span>
                <i>:</i>
                <div>{{ secondsToTime(holdTime, 'day')[1] }}</div>
                <span class="unit">时</span>
                <i>:</i>
                <div>{{ secondsToTime(holdTime, 'day')[2] }}</div>
                <span class="unit">分</span>
            </div>
        </div>
        <div class="cancel-queue" @click="cancelQueue"></div>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { secondsToTime } from '@/utils/util'

export default {
    computed: {
        ...mapGetters(['panelStatus'])
    },
    props: {
        holdTime: {
            type: Number,
            default: 0
        },
        person: {
            type: Number,
            default: 0
        },
    },
    components: {},
    data () {
        return {
            secondsToTime,
        }
    },

    mounted () {
    },
    methods: {
        ...mapMutations(['setPanelStatus', 'setShowLogin']),
        cancelQueue () {
            this.$emit('cancelQueue')
        }
    }
}
</script>
<style scoped lang="less">
.queuing-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 5;

    .cancel-queue {
        width: 387px;
        height: 104px;
        background: url("@/assets/images/queue/cancel-queue.png") no-repeat;
        background-size: 100% 100%;
        margin-top: 106px;
        cursor: pointer;
    }

    .queuing-title {
        width: 401px;
        height: 88px;
        background: url("@/assets/images/queue/queue-title.png") no-repeat;
        background-size: 100% 100%;
    }

    .queuing-now {
        color: #B0CAEB;
        width: 788px;
        height: 63px;
        background: url("@/assets/images/queue/queue-now.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        margin: 18px 0 55px 0;
    }

    .queuing-time {
        width: 293px;
        height: 39px;
        background: url("@/assets/images/queue/queue-time.png") no-repeat;
        background-size: 100% 100%;
    }
    .queuing-arrow {
        width: 24px;
        height: 13px;
        background: url("@/assets/images/queue/queue-arrow.png") no-repeat;
        background-size: 100% 100%;
        margin: 21px 0 15px 0;
    }
    .account-box {
        display: flex;
        align-items: center;
        padding: 0 10px 0 10px;
        box-sizing: border-box;
        justify-content: center;
        height: 140px;
        color: #FFD293;
        font-size: 90px;
        background: url("@/assets/images/queue/queue-time-bg.png") no-repeat;
        background-size: 100% 100%;
        font-weight: bold;
        &-main {
            display: flex;
            height: 90px;
            align-items: center;
        }
        i {
            font-style: normal;
            margin: 20px;
            //font-size: 12px;
        }
        span {
            font-size: 12px;
            display: flex;
            height: 80%;
            align-items: flex-end;
        }
    }
}
</style>
